import { FC, SyntheticEvent, useEffect, useState } from "react";
import BottomSticky from "../UI/BottomSticky";
import TabPanel from "@mui/material/Tabs";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Badge from "@mui/material/Badge";

import classes from "./Votes.module.css";
import VotesHeader from "./VotesHeader";
import VotePair from "./VotePair";
import RouterButton from "../UI/RouterButton";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";
import axios from "axios";
import { BattleModelDocument } from "../image/Image";
import GlobalAppLoading from "../UI/GlobalAppLoading";
import { getLang, i18n } from "../../i18n";

interface VoteModelDocument {
  _id: string;
  userID: string;
  battleID: string;
  artwork1UserID: string;
  artwork1ID: string;
  artwork1Src: string;
  artwork2UserID: string;
  artwork2ID: string;
  artwork2Src: string;
  selectedArtworkID?: string;
  status: string;
  rewardExpertRate: number;
  prevExpertRate?: number;
  expertRate: number;
  //reward: number;
  battle?: BattleModelDocument;
}

const Votes: FC = () => {
  const lang = getLang();
  const t = i18n.votes[lang];

  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [expertRate, setExpertRate] = useState(0);
  const [ongoingVotes, setOngoingVotes] = useState<VoteModelDocument[] | []>(
    []
  );
  const [finishedVotes, setFinishedVotes] = useState<VoteModelDocument[] | []>(
    []
  );
  const [value, setValue] = useState("ongoing");
  const handleTabChange = (
    e: SyntheticEvent<Element, Event>,
    tabIndex: any
  ) => {
    window.scrollTo({
      top: 31,
      behavior: "smooth",
    });
    setValue(tabIndex);
  };
  useEffect(() => {
    console.log("votes use effect");
    const getUserVotes = async () => {
      setScreenIsLoading(true);
      await axios
        .get(`${API_URL}/votes/results`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setExpertRate(response.data.expertRate);
          setOngoingVotes(response.data.ongoingVotes);
          setFinishedVotes(response.data.finishedVotes);
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setScreenIsLoading(false);
        });
    };

    getUserVotes();
  }, []);
  if (screenIsLoading) return <GlobalAppLoading text={t.loading} />;

  return (
    <>
      <VotesHeader expertRate={expertRate} />

      <section className={classes.votes}>
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleTabChange}
          className={classes.tabs}
        >
          <Tab
            value="ongoing"
            label={
              <Badge
                badgeContent={
                  ongoingVotes.length === 0 ? "0" : ongoingVotes.length
                }
                color="primary"
                className={classes.badge}
              >
                {t.tabOngoing}
              </Badge>
            }
          />

          <Tab
            value="finished"
            label={
              <Badge
                badgeContent={
                  finishedVotes.length === 0 ? "0" : finishedVotes.length
                }
                color="primary"
                className={classes.badge}
              >
                {t.tabFinished}
              </Badge>
            }
          />
        </Tabs>

        {value === "ongoing" && (
          <TabPanel value="ongoing">
            <div className="container">
              {ongoingVotes.length > 0 && (
                <div className={classes.list}>
                  {ongoingVotes.map((vote) => (
                    <VotePair
                      key={`vote-${vote._id}`}
                      isResult={false}
                      {...vote}
                      battle={vote.battle}
                    />
                  ))}
                </div>
              )}

              {ongoingVotes.length === 0 && (
                <div className={classes.empty}>{t.emptyOngoing}</div>
              )}
            </div>
          </TabPanel>
        )}

        {value === "finished" && (
          <TabPanel value="finished">
            <div className="container">
              {finishedVotes.length > 0 && (
                <div className={classes.list}>
                  {finishedVotes.map((vote) => (
                    <VotePair
                      key={`vote-${vote._id}`}
                      isResult={true}
                      {...vote}
                      battle={vote.battle}
                    />
                  ))}
                </div>
              )}

              {finishedVotes.length === 0 && (
                <div className={classes.empty}>{t.emptyFinished}</div>
              )}
            </div>
          </TabPanel>
        )}

        <BottomSticky>
          <div className="container">
            <RouterButton label={t.voteNow} href="/vote" />
          </div>
        </BottomSticky>
      </section>
    </>
  );
};

export default Votes;
